import React, { useState } from 'react';
import { Button, Clickable, Input, LoadingBalls, Overlay, Stack, Text } from '@moda/om';
import ExitIcon from '@moda/icons/exit-16';
import { tc } from '../../lib/trackingContext';
import { useUser } from '../../hooks/useUser';
import { useContactToPurchaseForm } from './useContactToPurchaseForm';
import { ContactToPurchaseFormRecaptcha } from './ContactToPurchaseFormRecaptcha';

import './ContactToPurchaseForm.scss';

type Props = { onSuccess: () => void; onClose: () => void };

export const ContactToPurchaseForm: React.FC<Props> = ({ onSuccess, onClose }) => {
  const TIMEOUT_MS = 3000;
  const { handleSubmit, formErrors, error, loading } = useContactToPurchaseForm({ onSuccess });

  const [canSubmit, setCanSubmit] = useState(false);

  const {
    user: { isLoggedIn }
  } = useUser();

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const elapsedTime = Date.now() - openTime;
    if (elapsedTime < TIMEOUT_MS) {
      handleModalClose();
    } else {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  const handleModalClose = () => {
    onClose();
    tc.track('Contact To Purchase Closed', {
      addToTrackingEvent: {
        label: 'X',
        location: 'Contact To Purchase Form Close button',
        form_location: location.pathname
      }
    });
  };

  const openTime = Date.now();

  return (
    <form className="ContactToPurchaseForm" onSubmit={handleFormSubmit}>
      <Clickable
        className="ContactToPurchaseForm__close"
        aria-label="Close"
        onClick={handleModalClose}
      >
        <ExitIcon />
      </Clickable>

      <Stack space={5}>
        <Stack space={4}>
          <Text className="ContactToPurchaseForm__title" treatment="h3" family="serif">
            Contact Us To Purchase
          </Text>
          <Text className="ContactToPurchaseForm__description">
            Please provide your information below and we will will get back to you with further
            details.
          </Text>

          <Input label="Full Name" name="name" error={formErrors.name?.message} />
          <Input label="Email" name="email" error={formErrors.email?.message} />
          <Input label="Phone Number" name="phone" />
          <Input label="Notes for Moda" name="notes" />
        </Stack>
        {error && <Text color="code-red">{error.message}</Text>}

        <div className="ContactToPurchaseForm__submit-row">
          {!isLoggedIn && <ContactToPurchaseFormRecaptcha setCanSubmit={setCanSubmit} />}
          <Button
            type="submit"
            className="ContactToPurchaseForm__submit"
            disabled={!canSubmit && !isLoggedIn}
          >
            Submit
          </Button>
        </div>
      </Stack>

      <Overlay show={loading}>
        <LoadingBalls />
        <Text treatment="eyebrow">Sending</Text>
      </Overlay>
    </form>
  );
};
